import { Checkbox, TableCell, TableRow } from "@mui/material";
import { useFormikContext } from "formik";
import { ICampaignFormState } from "../../App/Typings/Campaigns";
import FieldEditModal from "./FieldEditModal";
import { Draggable, DraggingStyle, NotDraggingStyle } from "react-beautiful-dnd";
import DragHandleIcon from "@mui/icons-material/DragHandle";
import FieldArchiveAction from "./FieldArchiveAction";

const requiredFields = [
  "firstName",
  "lastName",
  "contactPreference",
  "interestPicker",
  "email",
  "phone",
  "optIn",
];

export function FormTableRow({
  id,
  fieldName,
  index,
  dragDisabled,
  rowHidden,
}: {
  id: string;
  fieldName: string;
  index: number;
  dragDisabled?: boolean;
  rowHidden?: boolean;
}) {
  const formik = useFormikContext();
  const formValues = formik.values as ICampaignFormState;

  let dropdownAmount = "";

  if (
    formValues.formFields[id].fieldType === "dropdown" ||
    formValues.formFields[id].fieldType === "multiSelect"
  ) {
    dropdownAmount = `(${formValues.formFields[id].dropdownOptions.length})`;
  }

  const getItemStyle = (draggableStyle: DraggingStyle | NotDraggingStyle | undefined) => ({
    background: "white",
    ...draggableStyle,
  });

  const buildRow = (isDragDisabled: boolean) => {
    return (
      <>
        <TableCell>{isDragDisabled ? <></> : <DragHandleIcon />}</TableCell>
        <TableCell>
          <label
            htmlFor={`formFields-${id}-enabled`}
            aria-label={`toggle ${formValues.formFields[id].fieldName} enabled`}
            hidden
          />
          <Checkbox
            id={`formFields-${id}-enabled`}
            name={`formFields.${id}.enabled`}
            disableRipple
            disabled={requiredFields.includes(id)}
            checked={formValues.formFields[id].enabled}
            onChange={formik.handleChange}
          />
        </TableCell>
        <TableCell>
          <label
            htmlFor={`formFields-${id}-required`}
            aria-label={`toggle ${formValues.formFields[id].fieldName} enabled`}
            hidden
          />
          <Checkbox
            id={`formFields-${id}-required`}
            name={`formFields.${id}.required`}
            disableRipple
            disabled={requiredFields.includes(id)}
            checked={formValues.formFields[id].required}
            onChange={formik.handleChange}
          />
        </TableCell>
        <TableCell id={`field-row-${id}-fieldname`}>{fieldName}</TableCell>
        <TableCell id={`field-row-${id}-label`}>{formValues.formFields[id].label}</TableCell>
        <TableCell id={`field-row-${id}-fieldType`}>
          {`${formValues.formFields[id].fieldTypeLabel} ${dropdownAmount}`.trim()}
        </TableCell>
        <TableCell>
          <FieldEditModal action="edit" fieldToEdit={id} />
          <FieldArchiveAction disabled={requiredFields.includes(id)} fieldId={id} />
        </TableCell>
      </>
    );
  };

  return (
    <Draggable
      draggableId={"d-" + id}
      index={index}
      key={id}
      isDragDisabled={dragDisabled !== undefined ? dragDisabled : false}
      disableInteractiveElementBlocking={dragDisabled}
    >
      {(provided, snapshot) => (
        <TableRow
          key={fieldName}
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          style={{
            ...getItemStyle(provided.draggableProps.style),
            display: rowHidden ? "none" : "table-row",
          }}
        >
          {buildRow(dragDisabled !== undefined ? dragDisabled : false)}
        </TableRow>
      )}
    </Draggable>
  );
}
